jQuery(document).ready(function ($) {
  if ($('body').hasClass('page-template-ocrolus')) {
    const chart2025Q3FutureGrowth = document.getElementById('2025-q3-futuregrowth');

    new Chart(chart2025Q3FutureGrowth, {
      type: 'bar',
      data: {
        labels: ['Q3 2024', 'Q4 2024', 'Q1 2025', 'Q2 2025', 'Q3 2025'],
        datasets: [{
          label: 'Significant Growth',
          data: ['27', '30', '30', '26', '31'],
          backgroundColor: '#0064dd',
          borderColor: '#0064dd',
        },
        {
          label: 'Moderate Growth',
          data: ['65', '65', '63', '65', '62'],
          backgroundColor: '#000082',
          borderColor: '#000082',
        },
        {
          label: 'No Growth',
          data: ['8', '6', '7', '9', '7'],
          backgroundColor: '#83dcc1',
          borderColor: '#83dcc1',
        }]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            grid: { display: false },
          },
          y: {
            border: { display: false },
            ticks: {
              stepSize: 10,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            max: 70,
          }
        }
      }
    });

    // HTML legend plugin
    const getOrCreateLegendList = (chart, id) => {
      const legendContainer = document.getElementById(id);
      let listContainer = legendContainer.querySelector('ul');

      if (!listContainer) {
        listContainer = document.createElement('ul');
        listContainer.classList.add('flex-column', 'flex-lg-row');
        listContainer.style.display = 'flex';
        listContainer.style.flexWrap = 'wrap';
        listContainer.style.justifyContent = 'center';
        listContainer.style.margin = 0;
        listContainer.style.paddingTop = '1rem';
        listContainer.style.paddingBottom = '1rem';

        legendContainer.appendChild(listContainer);
      }

      return listContainer;
    };

    const htmlLineLegendPlugin = {
      id: 'htmlLineLegend',
      afterUpdate(chart, args, options) {
        const ul = getOrCreateLegendList(chart, options.containerID);

        // Remove old legend items
        while (ul.firstChild) {
          ul.firstChild.remove();
        }

        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);

        items.forEach(item => {
          const li = document.createElement('li');
          li.classList.add('ms-lg-6');
          li.style.alignItems = 'center';
          li.style.cursor = 'default';
          li.style.display = 'flex';
          li.style.flexDirection = 'row';

          // Color box
          const boxSpan = document.createElement('span');
          boxSpan.style.flex = '0 0 1.5rem';
          boxSpan.style.borderColor = item.strokeStyle;
          boxSpan.style.borderWidth = item.lineWidth + 'px';
          boxSpan.style.borderStyle = item.lineDash.length > 0 ? 'dashed' : 'solid';
          boxSpan.style.borderBottom = 'none';
          boxSpan.style.borderLeft = 'none';
          boxSpan.style.borderRight = 'none';
          boxSpan.style.display = 'inline-block';
          boxSpan.style.height = '0';
          boxSpan.style.margin = '0';
          boxSpan.style.width = '1.5rem';

          // Text
          const textContainer = document.createElement('p');
          textContainer.style.color = item.fontColor;
          textContainer.style.fontSize = '1.1rem';
          textContainer.style.margin = 0;
          textContainer.style.paddingTop = '.5rem';
          textContainer.style.paddingBottom = '.5rem';
          textContainer.style.paddingLeft = '.5rem';
          textContainer.style.paddingRight = 0;
          textContainer.style.fontWeight = '600';

          const text = document.createTextNode(item.text);
          textContainer.appendChild(text);

          li.appendChild(boxSpan);
          li.appendChild(textContainer);
          ul.appendChild(li);
        });
      }
    };

    const chart2025Q3DebtInflow = document.getElementById('2025-q3-debtinflow');

    new Chart(chart2025Q3DebtInflow, {
      type: 'bar',
      data: {
        labels: ['Q3 2024', 'Q4 2024', 'Q1 2025', 'Q2 2025', 'Q3 2025'],
        datasets: [
          {
            label: 'Non-bank',
            data: ['8186', '8178', '8541', '8114', '8226'],
            borderColor: '#0064dd',
            backgroundColor: '#0064dd',
            fill: false,
          },
          {
            label: 'Bank',
            data: ['8318', '6063', '5521', '7724', '7757'],
            borderColor: '#83dcc1',
            backgroundColor: '#83dcc1',
            fill: false,
          },
        ]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += '$' + context.parsed.y;
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            grid: { display: false },
            title: {
              display: true,
              text: 'Quarter / Year',
              padding: 20,
            },
          },
          y: {
            title: {
              display: true,
              text: 'Median Monthly Debt Inflow',
            },
            border: { display: false },
            ticks: {
              stepSize: 1000,
              callback: function (value, index, ticks) {
                return '$' + Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]);
              },
              padding: 20,
            },
            min: 0,
            max: 9000,
          }
        }
      }
    });

    const chart2025Q3RevToExpense = document.getElementById('2025-q3-revtoexpense');

    new Chart(chart2025Q3RevToExpense, {
      type: 'line',
      data: {
        labels: ['Q3 2024', 'Q4 2024', 'Q1 2025', 'Q2 2025', 'Q3 2025'],
        datasets: [{
          label: 'Accommodation & Food Services',
          data: ['99.8', '100.0', '99.9', '100.6', '100.4'],
          borderColor: '#0064dd',
          backgroundColor: '#0064dd',
          pointBackgroundColor: '#0064dd',
        },
        {
          label: 'Construction',
          data: ['101.9', '101.1', '100.8', '102.0', '101.8'],
          borderColor: '#83DCC1',
          backgroundColor: '#83DCC1',
          pointBackgroundColor: '#83DCC1',
        },
        {
          label: 'Manufacturing',
          data: ['100.6', '100.8', '100.7', '100.9', '100.8'],
          borderColor: '#000082',
          backgroundColor: '#000082',
          pointBackgroundColor: '#000082',
        },
        {
          label: 'Professional, Scientific & Technical Services',
          data: ['100.5', '100.5', '100.2', '101.6', '100.3'],
          borderColor: '#767676',
          backgroundColor: '#767676',
          pointBackgroundColor: '#767676',
        },
        {
          label: 'Retail Trade',
          data: ['100.5', '100.7', '101.1', '101.3', '101.0'],
          borderColor: '#DDDDDD',
          backgroundColor: '#DDDDDD',
          pointBackgroundColor: '#DDDDDD',
        },
        {
          label: 'Transportation & Warehousing',
          data: ['101.9', '101.9', '101.8', '101.8', '101.7'],
          borderColor: '#2B7665',
          backgroundColor: '#2B7665',
          pointBackgroundColor: '#2B7665',
        },
        {
          label: 'Wholesale Trade',
          data: ['100.9', '100.4', '100.1', '100.7', '100.7'],
          borderColor: '#895E01',
          backgroundColor: '#895E01',
          pointBackgroundColor: '#895E01',
        },
        {
          label: 'All Industries',
          data: ['100.6', '100.5', '100.5', '101.0', '100.8'],
          borderColor: '#010135',
          backgroundColor: '#010135',
          pointBackgroundColor: '#010135',
          borderDash: [5, 5],
          borderCapStyle: 'round',
        }
        ]
      },
      plugins: [htmlLineLegendPlugin],
      options: {
        plugins: {
          htmlLineLegend: {
            containerID: '2025-q3-revtoexpense-legend',
          },
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ' + context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        clip: false,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Quarter / Year',
            },
            ticks: {
              padding: 24,
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            }
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Ratio',
            },
            ticks: {
              stepSize: 1,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            min: 99,
            max: 102,
          }
        }
      }
    });
  }
});
